import React, { useState, useMemo } from "react";
// reactstrap components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    CardBody,
    Progress,
    Modal,
    ModalBody
} from "reactstrap";
// core components

import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import BlockUi from 'react-block-ui';
import ReduxBlockUi from "react-block-ui/redux";
import "react-block-ui/style.css";
import { useForm } from "react-hook-form";
import MessageBox from "../../../components/ui/MessageBox";

import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/readingbook/EditUnitRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import UnitService from "../../../services/screens/admin/unit/forms/UnitService";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import ReadingDialogField from "../unit/fields/types/ReadingDialogField";
import UIDs from "../../../UIDs";
import "antd/dist/antd.css";
import { HotKeys } from "react-hotkeys";
import "../../../assets/scss/screens/admin/unit/unit.scss";
const uid = UIDs.screens.admin.readingbook.editunit;

class EditUnitScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_UNIT_ASYNC]: { done: this._handleSaveUnitAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);

        let { id, sectionId, index } = this.localVars.navParams;
        this.props.loadScreenViewAsync(id, sectionId, index);
    }

    componentDidMount() {
        super.componentDidMount();                     
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        let hotkeysScope = this.refs.hotkeysScope;
        hotkeysScope && hotkeysScope.focus();       
    }

    hotkeysKeyMap = {
        CANCEL: "alt+q",
    }

    hotkeysHandler = {
        CANCEL: () => this._handleCancel(),
    }

    render() {  
        const { courseName, sectionName, order, unit, resourceId } = this.props.localState;      
        return (
            <HotKeys keyMap={this.hotkeysKeyMap} handlers={this.hotkeysHandler}>
                <div ref="hotkeysScope" tabIndex="0">
                    <Container className="mt--7 aic-singleUnit-style" fluid>
                        <ReduxBlockUi tag="div" block={[ActionTypes.LOAD_SCREEN_VIEW_ASYNC, ActionTypes.SAVE_UNIT_ASYNC]} 
                            unblock={[ActionTypes.LOAD_SCREEN_VIEW_SUCCESS, ActionTypes.LOAD_SCREEN_VIEW_FAILURE, ActionTypes.SAVE_UNIT_SUCCESS, ActionTypes.SAVE_UNIT_FAILURE]}>
                            <UnitForm 
                                key={`unitForm-${unit.id}`} 
                                t={this.props.t} 
                                localVars={this.localVars.navParams}
                                hotkeysHandler={this.hotkeysHandler} 
                                data={{ courseName, sectionName, order, unit }} 
                                resourceId={resourceId} 
                                onSave={this._handleSave} 
                                onCancel={this._handleCancel} />                           
                        </ReduxBlockUi>     
                    </Container>
                </div>
            </HotKeys>
        );
    }

    _handleSave = formData => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        const { unit, resourceId } = this.props.localState;
                        const { id, unitType, ownerType, ownerId, data } = unit;
                        let vo = { id, unitType, ownerType, ownerId, resourceId, dataType: formData.dataType, data: JSON.stringify({ ...data, ...formData.data }) };
                        this.props.saveUnit(vo);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancel = () => {
        confirmAlert({
            title: this.props.t("confirmToCancel"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        const { courseId, sectionId, sectionIndex } = this.localVars.navParams;
                        NavigationService.navigateToPage(this, `/admin/readingbook/${courseId}/details`, { sectionId, sectionIndex });   
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveUnitAsyncDone = (data) => {
        const { courseId, sectionId, sectionIndex } = this.localVars.navParams;
        NavigationService.navigateToPage(this, `/admin/readingbook/${courseId}/details`, { sectionId, sectionIndex });
    }  

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

const UnitForm = (props) => {
    const { resourceId, data, localVars } = props;  
    const { courseName, sectionName, order, unit } = data;
    const { sectionIndex, sectionType } = localVars;
    const num = sectionIndex + 1;
    const type = sectionType === 0 ? props.t("chapter") : sectionType === 1 ? props.t("lesson") : sectionType === 2 ? props.t("section") : "";
    const title = `${courseName} / ${props.t("sectionNo", { num, type })} ${sectionName} ` + (order > 0 ? "/ " : "") + props.t("queNum", { order });          

    //form hook helper func
    const formMethods = useForm();

    const [state_showDetails, setstate_showDetails] = useState(false);
    const [state_generatingUnit, setstate_generatingUnit] = useState(false);
    const [state_unit, setstate_unit] = useState(unit);
    const [state_tempChanged, sestate_tempChanged] = useState(false); 
    const [state_progress, setstate_progress] = useState(null); 

    const buildSingleUnit = (singleUnit = {}) => {
		return Object.assign(
			{
				paragraphs: [
                    {
                        sentences: [
                            {
                                chars: [],
                                syllables: [],
                                translation: {},
                                audioPath: ""
                            }
                        ]
                    }                    
                ], 
                audioPath: ""
			},
			singleUnit
		);
	};

    const buildFormData = newFormData => {
        var buildFieldsData = ReadingDialogField.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = ReadingDialogField.WrappedComponent.buildFieldsData;
        }

        let submitData = buildFieldsData(newFormData);
        return submitData;
    }

    const onSave = newFormData => {        
        let submitData = {};
        try {
            submitData = buildFormData(newFormData);
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }
        props.onSave(submitData);
    };

    const onHandleUpdateProgress = (taskId) => {
        UnitService.getTaskProgress(
            taskId,
            (response) => {
                setstate_progress(response.progress);
                if (response.progress >= 100) {   
                    var responseData = JSON.parse(response.data);
                    responseData = Helper.convertSnakeCaseKeysToCamelCase(responseData);
                    if(responseData.isDone){
                        previewSuccessCallback(responseData.data);
                        //setstate_generatingUnit(false);    
                    } else{
                        MessageBox.danger({ text: responseData.message, duration: 5000 });
                    }
                    setstate_progress(null);
                } else {
                    setTimeout(() => onHandleUpdateProgress(taskId), 2000);
                }
            },
            (error) => {
                setstate_progress(null);
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    }

    const onNext = newFormData => {                
        let submitData = {};
        try {
            submitData = buildFormData(newFormData);
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        const { id, unitType, ownerType, ownerId } = state_unit;
        if (submitData.charsChanged) {
            sestate_tempChanged(true);
            setstate_progress(0);
            let vo = { id, unitType, ownerType, ownerId, resourceId, dataType: submitData.dataType, data: JSON.stringify(submitData.data) };        
            UnitService.generateUnitByTask(
                vo,
                (response) => {
                    setTimeout(() => onHandleUpdateProgress(response), 2000);
                },
                (error) => {
                    MessageBox.danger({ text: error.message, duration: 5000 });
                }
            );
        } else {
            let unit = { ...state_unit, data: submitData.data.singleUnits[0] };
            setstate_unit(unit);
            setstate_showDetails(true);
        }
    };

    const previewSuccessCallback = (unit) => {
        unit.data = JSON.parse(unit.data).singleUnits[0];
        setstate_unit(unit);
        setstate_showDetails(true);            
    };

    const onCancel = () => {
        props.onCancel();           
    };

    const onBack = newFormData => {
        let submitData = {};
        try {
            submitData = buildFormData(newFormData);
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        let unit = { ...state_unit, data: submitData.data.singleUnits[0] };
        setstate_unit(unit);
        setstate_showDetails(false);
    };
    
    const { hotkeysHandler } = props;

    const formHotKeysHandler = e => {
        e = e || window.event;
        if (e.keyCode === 83 && e.altKey) {//alt+s,alt+S
            formMethods.handleSubmit(onSave)()
        }
        if (e.keyCode === 82 && e.altKey) {//alt+r,alt+R
            formMethods.reset()
        }
        if (e.keyCode === 81 && e.altKey) {//alt+q,alt+Q
            hotkeysHandler.CANCEL();
        }
    };

    const bindHotkeys = setInterval(() => {
        const unitForm = document.getElementById("unitForm");
        if (unitForm) {
            const inputs = unitForm.querySelectorAll("input,textarea");
            Array.from(inputs).map(e => e.onkeydown = formHotKeysHandler)
            clearInterval(bindHotkeys);
        }
    }, 100);

    window.onkeydown = formHotKeysHandler;

    const { data: unitData } = state_unit;
    const { paragraphs, audioPath, subject } = buildSingleUnit(unitData || {});

    let fieldPayload = useMemo(() => ({
        subject: { name: "subject", value: subject },
        article: { name: "article", index: 0, value: { paragraphs, audioPath } },
    }), [unitData]);

    return (
        <>
        <Row>
            <Col>
                <Card className="shadow">
                    <CardHeader className="bg-white border-1">
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">{title}</h3>
                            </Col>
                            <Col className="text-right" xs="4">
                                {!state_showDetails ? (
                                    <Button disabled={state_generatingUnit} size="sm" color="primary" onClick={formMethods.handleSubmit(onNext)}>{props.t("nextStep")}</Button> 
                                ) : (
                                    <Button size="sm" color="primary" onClick={formMethods.handleSubmit(onSave)}>{props.t("save")}</Button>
                                )}
                                {!state_showDetails ? (
                                    <Button size="sm" color="default" onClick={onCancel}>{props.t("cancel") + "(Q)"}</Button>
                                ) : (
                                    <Button size="sm" color="default" onClick={formMethods.handleSubmit(onBack)}>{props.t("back") + "(Q)"}</Button>
                                )}
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {state_showDetails && state_tempChanged &&
                            <div className="alert alert-warning">
                                <span>{props.t("changesNeedSaveNote")}</span>
                            </div>}
                        <BlockUi tag="div" blocking={state_generatingUnit}>
                            <form id="unitForm">
                                <ReadingDialogField formMethods={formMethods} fields={fieldPayload} resourceId={resourceId} showDetails={state_showDetails} />
                            </form>   
                        </BlockUi>                          
                    </CardBody>                        
                </Card>
            </Col>
        </Row>
        <Modal isOpen={state_progress !== null} centered backdrop="static">
            <ModalBody style={{ padding: "0.7rem" }}>
                <Progress value={state_progress} style={{ height: 40, margin: 0 }}>{state_progress}%</Progress>
            </ModalBody>
        </Modal>
        </>
    );
};

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (id, sectionId, index) => dispatch(Actions.loadScreenViewAsync(id, sectionId, index)),
        saveUnit: vo => dispatch(Actions.saveUnitAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditUnitScreen));
